import { z } from 'zod';
import { yesNoRequired } from '@utils/form-schema';

export const assessOrganDiseaseSchema = z.object({
    hasHadOrganDisease: yesNoRequired,
});
